import React from 'react';

import { FreecodeButton } from 'components/Button/RectangleButton';
import { Modal, Header, Body, Footer, FooterButton } from './modalElements';
import { ModalContent } from './styles';

// A generic modal that can display some text and confirm or cancel
export default React.memo(
  ({ title, text, onConfirm, onCancel, isOpen = true, loading = false, isFreecodeModal = false }) => {
    return (
      <Modal isOpen={isOpen} isFreecodeModal={isFreecodeModal}>
        {title && <Header isFreecodeModal={isFreecodeModal}>{title}</Header>}
        <Body loading={loading}>{text && <ModalContent>{text}</ModalContent>}</Body>
        <Footer isFreecodeModal={isFreecodeModal}>
          {onCancel &&
            (isFreecodeModal ? (
              <FreecodeButton isFreecodeButton onClick={onCancel}>
                Cancel
              </FreecodeButton>
            ) : (
              <FooterButton label="Cancel" onClick={onCancel} />
            ))}
          {isFreecodeModal ? (
            <FreecodeButton isFreecodeButton disabled={loading} onClick={onConfirm}>
              Confirm
            </FreecodeButton>
          ) : (
            <FooterButton label="Confirm" onClick={onConfirm} disabled={loading} />
          )}
        </Footer>
      </Modal>
    );
  }
);
